// extracted by mini-css-extract-plugin
var _1 = "TableOfContents-module__active--P2wYC";
var _2 = "TableOfContents-module__animatedBackground--O52jS";
var _3 = "TableOfContents-module__collapsed--Z7YwG";
var _4 = "TableOfContents-module__level2--dE8RF";
var _5 = "TableOfContents-module__level3--WzxQj";
var _6 = "TableOfContents-module__small--tbHG9";
var _7 = "TableOfContents-module__toc--qfoia";
export { _1 as "active", _2 as "animatedBackground", _3 as "collapsed", _4 as "level2", _5 as "level3", _6 as "small", _7 as "toc" }
